import { render } from "./PointGuessingRecord.vue?vue&type=template&id=29a83d8f&scoped=true&ts=true"
import script from "./PointGuessingRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./PointGuessingRecord.vue?vue&type=script&setup=true&lang=ts"

import "./PointGuessingRecord.vue?vue&type=style&index=0&id=29a83d8f&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a83d8f"],['__file',"src/views/me/PointGuessingRecord.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29a83d8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29a83d8f', __exports__)) {
    console.log('reload')
    api.reload('29a83d8f', __exports__)
  }
  
  module.hot.accept("./PointGuessingRecord.vue?vue&type=template&id=29a83d8f&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('29a83d8f', render)
  })

}


export default __exports__